import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Habit } from './_types';

// Fields that the server sends down on habit payloads but refuses to accept on
// create/update. `start_date_string` / `end_date_string` in particular would
// otherwise clobber `start_date` / `end_date` updates on the server side.
const readOnlyFields = [
  'created_at',
  'updated_at',
  'start_date_string',
  'end_date_string',
  'revision',
];

export function normalizeHabit<T = Habit>(habit: unknown): T {
  return camelcaseKeys(habit as Record<string, unknown>, { deep: true }) as T;
}

export function denormalizeHabit(
  habit: Partial<Habit>
): Record<string, unknown> {
  const decamelized = decamelizeKeys(habit, { deep: true }) as Record<
    string,
    unknown
  >;
  removeReadOnlyFields(decamelized, readOnlyFields);
  return decamelized;
}
